export enum HeadingType {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3"
}
export enum HeadingWeight {
  BOLD = "bold",
  MEDIUM = "medium",
  NORMAL = "normal",
  LIGHT = "light"
}
